import { render, staticRenderFns } from "./EditorModelChoose.vue?vue&type=template&id=2a526052&scoped=true"
import script from "./EditorModelChoose.vue?vue&type=script&lang=js"
export * from "./EditorModelChoose.vue?vue&type=script&lang=js"
import style0 from "./EditorModelChoose.vue?vue&type=style&index=0&id=2a526052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a526052",
  null
  
)

export default component.exports